module.exports = __webpack_public_path__ + "img/table.9ced91e1.svg";